export const OM_STATE_NAME = 'orderMgmt';
